import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import api from '@/api';
import Edit from '../edit/index';
export default {
  name: 'popNotice',
  components: {
    Edit: Edit
  },
  data: function data() {
    return {
      isSelect: true,
      pageNo: 1,
      pageSize: 10,
      tableData: [],
      pageTotal: 0,
      editDisabled: false,
      dialogVisible: false,
      selectForm: {}
    };
  },
  created: function created() {
    this.initTableData();
  },
  methods: {
    checkPushObject: function checkPushObject(pushObject) {
      if (pushObject === 0) {
        return '注册用户';
      } else if (pushObject === 1) {
        return '会员用户';
      } else if (pushObject === 2) {
        return '红娘用户';
      } else {
        return '全部用户';
      }
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    toEdit: function toEdit(data) {
      this.$refs.edit.setTitle('编辑弹窗');
      this.$refs.edit.setData(data);
      this.dialogVisible = true;
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增弹窗');
      this.$refs.edit.initData();
      this.dialogVisible = true;
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    dalete: function dalete(id) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                var data;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      data = {
                        noticeId: id
                      };
                      _context.n = 1;
                      return api.DELETE_POP_NOTICE(data);
                    case 1:
                      _this.$message.success('操作成功');
                      _this.initTableData();
                    case 2:
                      return _context.a(2);
                  }
                }, _callee);
              }))).catch(function () {
                _this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    initTableData: function initTableData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                pageNo: _this2.pageNo,
                pageSize: _this2.pageSize
              };
              _context3.n = 1;
              return api.GET_POP_NOTICE_PAGE_LIST(par);
            case 1:
              res = _context3.v;
              _this2.tableData = res.body.datas;
              _this2.pageTotal = res.body.sumDataCount;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  }
};